"use client";

import { motion } from "framer-motion";

function Triangle({
  isAnimated = false,
  className = "",
  width = 30,
  height = 30,
  strokeWidth = 1.1,
}) {
  const variants = {
    animate: {
      opacity: [0.2, 1, 0.2],
      transition: {
        duration: Math.random() * 2 + 1,
        ease: "easeInOut",
        repeat: Infinity,
      },
    },
  };

  return (
    <motion.svg
      variants={isAnimated ? variants : {}}
      animate={isAnimated ? "animate" : ""}
      className={`opacity-50 ${className}`}
      width={width}
      height={height}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29 27H15.3426H1L15.3426 2L29 27Z"
        strokeWidth={strokeWidth}></path>
    </motion.svg>
  );
}

export default Triangle;
